import { OtoIndividualProposition } from '../../lib/types/models/enrollment-proposition/oto-individual-proposition'
import { OtoIndividualPropositionRequest } from '../../lib/types/models/enrollment-proposition/oto-individual-proposition-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateOtoIndividualProposition(data: IdInput<OtoIndividualPropositionRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollments.updateOtoIndividualProposition.url, { id }))
    .patch<OtoIndividualProposition, OtoIndividualPropositionRequest>(rest)
}
